import { DatePipe } from '@angular/common';
import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { GlobalSetting } from 'projects/Autofacets-Core/src/app/common-services/global-setting.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { NgInfoModalContent } from 'projects/Autofacets-Core/src/app/shared/info-modal.component';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { AppointmentDetail } from '../../business-entities/appointmentDetail-model';
import { AppointmentRequestModel, UpdateAppointmentStatusDisplyModel } from '../../business-entities/appointmentList-model';
import { AppointmentStatus, AppointmentStatusList, WorkOrderStatus } from '../../business-entities/appointmentStatus-model';
import { BrandViewModel } from '../../business-entities/brand-view-model';
import { UserDealersModel } from '../../business-entities/dealer-details.model';
import { DealerViewModel } from '../../business-entities/dealer-view-model';
import { AppointmentService } from '../../business-services/appointment.service';
import { DealerBusinessService } from '../../business-services/dealer.service';
import { EditAppointmentService } from '../../business-services/edit-appointment.service';
import { MechanicService } from '../../business-services/mechanic.service';
import { ServiceAdvisorService } from '../../business-services/service-advisor.service';
import { OnholdStatusChangeComponent } from '../onhold-status-change/onhold-status-change.component';
import * as Enums from './../../../../../Autofacets-Core/src/app/utils/enums';
import { MultiStackPopupService } from '../../services/multi-stack-popup.service';
import { AdminCommonService } from '../../services/admin-common.service';
import { AppLinkService } from '../../business-services/app-link.service';
import { BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import * as CommonEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { Features } from '../../business-entities/user-role-view-model';
@Component({
  selector: 'app-service-advisor',
  templateUrl: './service-advisor.component.html',
  styleUrls: ['./service-advisor.component.css']
})
export class ServiceAdvisorComponent implements OnInit {
  zoomClass: string = 'zoom-100';
  isCollapsed: { [key: string]: boolean } = {};
  isAdvanceSearch:any;
  statusData:any
  dealerList: DealerViewModel[];
  dealers: DealerViewModel[] = [];
  dealerId: string = '0';
  id: string = '0';
  bookingDate: any[] = [];
  createdDate: any[] = [];
  formatDate: string = 'd.m.Y';
  appointmentstatusList: AppointmentStatus[];
  workOrderStatusList: WorkOrderStatus[];
  status: AppointmentStatus[] = [];
  workOrderStatus:WorkOrderStatus[] = [];
  searchTerm:string;
  todayViewDate:any;
  weekViewDate:any;
  isTodayViewOn:boolean;
  isWeekViewOn:boolean;
  langCode:any;
  selectedDealer:any;
  InvoicePrice : any = 0;
  isDisplayInvoice:boolean = false;
  isCurrentAppointmentOnHold:boolean=false;
  appointmentRequestModel: AppointmentRequestModel =
  {
    appointmentStatusId: null,
    workOrderStatusId: null,
    bookingDate: null,
    createdDate: null,
    dealerId: null,
    serviceAdvisorId:null,
    isAuthorizedByServiceAdvisor:false,
    mechanicId:null,
    searchTerm: '',
    startRecordNumber: 0,
    pageSize: 0,
    sortColumn: '',
    sortDirection: '',
    brandCode: null
  };  
  myDateRangePickerOptions: Partial<BsDaterangepickerConfig> = Object.assign({},{
    containerClass: 'theme-dark-blue',
    displayMonths:1,
    showWeekNumbers:false,
    rangeInputFormat: 'DD/MM/YYYY',
    customTodayClass: 'custom-today-class'
  });
  closeResult: string;
  statusList:[]=[];
  SelectedStatus:any=null;
  popupCloseResult = false;
  updateAppointmentStatusModel: UpdateAppointmentStatusDisplyModel={
      WOnumber:'',
      WOstatus:null,
      WOstatusColor:'',
      WOstatusId:0,
      appointmentStatus:'',
      appointmnetStatusColor:'',
      bookDate:'',
      customerName:'',
      dealerName:'',
      licensePlate:'',
      appointmentId:0,
      appointmentStatusId:0,
      brandImg:'',
      model:'',
      appointmentGuid: '',
    bookDateTime: null,
    makeCode: ''
  }
  contactDetails: AppointmentDetail;
  isSingleClick: boolean = true;
  brandList: BrandViewModel[];
  appointmentStatusList:AppointmentStatusList[] = []
  isOpenByOtherUser: boolean = false;
  isOpenByOtherUserMsg: string = "";
  isShowDMSStatus:boolean = false;
  featureList: Features[] = [];
  constructor(
    private adminCommonService :AdminCommonService,
    public serviceAdvisorService :ServiceAdvisorService,
    private translate: TranslateService,
    public mechanicService: MechanicService,
    private appointmentService: AppointmentService,
    private userService: UserDataService,
    private spinner: NgxSpinnerService,
    private globalSetting: GlobalSetting,
    private datePipe: DatePipe,
    private currentLanguageService: CurrentLanguage,
    private modalService: NgbModal,
    private cookieservice: CookieService,
    private toastr: ToastrService,
    private editAppointmentService: EditAppointmentService,
    public dealerBusinessService: DealerBusinessService,
    public secureStorage: SecureStorage,
    private multiStackPopupService: MultiStackPopupService,
    private _eref: ElementRef,
    private appLinkService: AppLinkService,
  ) { }

  ngOnInit(): void {
    if (this.secureStorage.getKeyData('feature')) {
      this.featureList = this.secureStorage.getKeyData('feature');
      if (this.featureList?.length > 0) {
        this.isShowDMSStatus = this.featureList.find(x => x.featureCode === CommonEnums.FeatureCode.ShowDMSStatus)?.isActive;
      }
    }
    setInterval(() => {
      this.updateZoomClass();
    }, 500);
    this.isCurrentAppointmentOnHold=false;
    this.dealerId=this.userService.currentUserValue.dealerId;
    this.loadTodayView();
    this.getUserDealers();
    this.GetAllWorkOrderStatus();
    this.appointmentRequestModel.dealerId = this.userService.currentUserValue.defaultDealerId;
    this.selectedDealer = this.userService.currentUserValue.defaultDealerId;
    this.appointmentRequestModel.languageCode=this.cookieservice.get('userSelectedLanguage');
    this.getAllServiceAdvisorDetails(this.appointmentRequestModel);
    this.multiStackPopupService.onCloseTrigger.subscribe((res)=>{
      if (res) {
        if(this.isWeekViewOn)
        {
          this.loadWeekView();
        }
        else if(this.isTodayViewOn)
        {
          this.loadTodayView()
        }
      }
    });
  }
  private updateZoomClass(): void {
    const currentHeight = window.innerHeight; 
    const originalHeight = window.screen.height; 
    if (currentHeight <= 923) {
      this.zoomClass = 'zoom-100'; 
    } else if (currentHeight >= 924 && currentHeight <= 1025) {
      this.zoomClass = 'zoom-90'; 
    } else if (currentHeight >= 1026 && currentHeight <= 1153) {
      this.zoomClass = 'zoom-80'; 
    } else {
      this.zoomClass = 'zoom-70'; 
    }
  }
  @HostListener('document:click', ['$event'])
  onSearchBoxClose(event) {
    if (event) {
      if (!this._eref.nativeElement.getElementsByClassName('advanced-search-box')[0]?.contains(event.target)) {
        this.isAdvanceSearch = false;
      }
    }
  }

  toggleCollapse(index: number, key: string): void {
    const collapseKey = `${index}_${key}`;
    this.isCollapsed[collapseKey] = !this.isCollapsed[collapseKey];
  }
  onDoubleClick(){
    this.dealerId=this.userService.currentUserValue.dealerId;
    this.getAllServiceAdvisorDetails(this.appointmentRequestModel);
  }
  onClickChangeView(isWeek:boolean){
    if(isWeek){
      this.loadWeekView()
    } else{
      this.loadTodayView()
    }
    this.appointmentRequestModel.languageCode=this.cookieservice.get('userSelectedLanguage');
    this.getAllServiceAdvisorDetails(this.appointmentRequestModel);
  }

  async getUserDealers(){
    await this.dealerBusinessService.getUserDealersDropdown().then((response) => {
      this.dealerList = this.mapdealer(response.userDealersModel);
      this.dealers=this.mapDealerListToDealers(response.userDealersModel)
      if(this.dealers?.length===1)
      {
        this.selectedDealer=this.dealers[0].dealerId;
      }

          })
  }

  mapdealer(array: UserDealersModel[]){
    let supperArray = [];
    if (array && array.length > 0) {
      array.forEach(element=>{
        let single = Object();
        single.value = element.dealerId
        single.text = element.dealerName
        supperArray.push(single);
      })
    }
    return supperArray;
  }
 
  onStatusChange() {
    if (!this.SelectedStatus) {
        return;
    }
    if (this.SelectedStatus === Enums.WOStatus.Workdone) {
      this.GetAdditionalServiceDetail();
    }
    if (this.SelectedStatus === Enums.WOStatus.OnHold) {
        this.handleOnHoldStatus();
    } else if (this.SelectedStatus === Enums.WOStatus.Cancelled) {
        this.handleCancelledStatus();
    }

    this.isDisplayInvoice = this.SelectedStatus === Enums.WOStatus.InvoicePaid;
}
  GetAdditionalServiceDetail() {
    let isAnyDemand = false;
    this.appointmentService.GetAdditionalServiceDetail(this.editAppointmentService.appointmentDetails.id).then(data => {
      if (data.responseObject != null) {
        var appointmentDemandList = data.responseObject.appointmentDemandList;
        if (appointmentDemandList.length > 0) {
          var additionalDemand = appointmentDemandList.filter(x => x.demandNo > 100 && x.isAdditionalWork == true);
          if (additionalDemand.length > 0) {
            var pendingAdditionalDemand = additionalDemand.filter(x => x.isAdminApproved == 0 && x.isCustomerApporved == 0 && x.isMechanicApproved == 0 && x.isCDSSApproved == 0);
            if (pendingAdditionalDemand.length > 0) {
              isAnyDemand = true;
              let msg = this.translate.instant("lblWorkDoneStatusError");
              this.toastr.error(msg);
              this.resetCalculations();
            }
          }
        }
      }
    });
    return isAnyDemand;
  }
  resetCalculations() {
    this.SelectedStatus = null;
  }
handleOnHoldStatus() {
    const modalref = this.modalService.open(OnholdStatusChangeComponent,
        { size: 'lg', windowClass: 'pop-wid800 ' });

    modalref.componentInstance.currentWorkorderStatusId = this.updateAppointmentStatusModel.WOstatusId;
    modalref.componentInstance.appointmentId = this.updateAppointmentStatusModel.appointmentId;
    modalref.componentInstance.workOrderNumber = this.updateAppointmentStatusModel.WOnumber;
    modalref.componentInstance.isLockedByOtherUser = this.isOpenByOtherUser;

    modalref.result.then(
        (response) => this.handleModalResponse(response),
        () => this.refresh()
    );
}

handleCancelledStatus() {
    this.adminCommonService.openStatusChangeModal(
        this.updateAppointmentStatusModel.appointmentId,
        this.updateAppointmentStatusModel.WOnumber,
        this.isOpenByOtherUser,
        this.updateAppointmentStatusModel.appointmentType,
        this.updateAppointmentStatusModel.appointmentGuid
    ).then(
        (response) => this.handleModalResponse(response),
        () => this.refresh()
    );
}

handleModalResponse(response) {
    if (response.success && response.isKeepOnHold === true) {
        this.modalService.dismissAll();
        this.refresh();
    } else {
        this.SelectedStatus = null;
    }
}

  mapDealerListToDealers(array: UserDealersModel[]){
    let supperArray = [];
    if (array && array.length > 0) {
      array.forEach(element=>{
        let single = Object();
        single.dealerId = element.dealerId
        single.name = element.dealerName
        supperArray.push(single);
      })
    }
    return supperArray;
  }

  loadTodayView(){
    this.isTodayViewOn= true;
    this.isWeekViewOn= false;
    let todays_date = new Date();
    this.bookingDate= [];
    this.bookingDate.push(todays_date);
    this.bookingDate.push(todays_date);
    this.todayViewDate= this.datePipe.transform(new Date(),'dd/MM/yyyy') +' - '+this.datePipe.transform(new Date(),'dd/MM/yyyy');
    this.appointmentRequestModel.bookingDate=this.todayViewDate;
  }

  loadWeekView(){
    this.isTodayViewOn= false;
    this.isWeekViewOn= true;
    //Task 2235
    const  { weekViewDate, bookingDate } =this.adminCommonService.getWeekViewDatesNew(1);
    this.bookingDate = [...bookingDate];
    this.appointmentRequestModel.bookingDate= weekViewDate; //Load today's booking
  }
  //Get All Dealers for Advance search
  getAllServiceAdvisorDetails(appointmentRequestModel : AppointmentRequestModel){
    this.statusData = null;
    this.spinner.show();
    this.appointmentRequestModel.searchTerm = this.searchTerm;
    this.serviceAdvisorService.getServiceAdvisorDetails(appointmentRequestModel).then(data=>{
      this.spinner.hide();
      this.isCollapsed={};
      this.statusData = this.AddBrandImage(data);
    });
  }
  AddBrandImage(data:any){
    data.forEach(element => {
      if(element.workOrderList?.length > 0)
      {
      element.workOrderList.forEach(ele => {
        ele.bookedDate = Utility.GetFormattedDateTime(Utility.ConvertUTCDateToLocalDate(ele.bookedDate));
        ele.mechanicList = ele.mechanic.split(", ");
      });
    }
    if(element.subList?.length > 0){
      element.subList.forEach(elements => {
        elements.workOrderList.forEach(workorder => {
          workorder.bookedDate = Utility.GetFormattedDateTime(Utility.ConvertUTCDateToLocalDate(workorder.bookedDate));
          workorder.mechanicList = workorder?.mechanic.split(", ");
        });
      });
    }
    if(element.subList?.length > 0){
      element.subList.forEach(ele => {
        ele.workOrderList.forEach(wo => {
          wo.bookedDate = (wo.bookedDate);
          wo.mechanicList = wo?.mechanic.split(", ");
        });
      });
    }
    });
    return data;
  }
   GetAllWorkOrderStatus(){
    let language;
    this.langCode = this.currentLanguageService.currentLanguage.subscribe(x => {
      language = x;

    })
    let model={
      DealerId: this.dealerId,
      LanguageCode:language
    }
    this.appointmentService.GetAllWorkOrderStatus(model).then(data => {
      this.workOrderStatusList = data.responseObject.workOrderStatusList;
      for (let value of this.workOrderStatusList){
        this.workOrderStatus.push(value)
      }
      this.appointmentstatusList = data.responseObject.appointmentStatusList;
      for (let value of this.appointmentstatusList){
        this.status.push(value)
      }
    })
  }

  AdvanceSearchSubmit(){
    this.isTodayViewOn=false;
    this.isWeekViewOn=false;
    let bookingDateFormatted= this.getFormattedDate(this.bookingDate);
    let createdDateFormatted= this.getFormattedDate(this.createdDate);
    
    this.appointmentRequestModel.bookingDate= bookingDateFormatted;
      this.appointmentRequestModel.createdDate=createdDateFormatted;

    this.appointmentRequestModel.searchTerm= this.searchTerm;
    this.appointmentRequestModel.languageCode=this.cookieservice.get('userSelectedLanguage');
    this.getAllServiceAdvisorDetails(this.appointmentRequestModel);
    this.isAdvanceSearch = false;
  }

  onReset() {
    this.appointmentRequestModel.appointmentStatusId = null;
      this.appointmentRequestModel.workOrderStatusId = null;
      this.bookingDate = [];
      this.createdDate = [];
      this.appointmentRequestModel.createdDate = null;
      this.appointmentRequestModel.bookingDate = null;
      this.appointmentRequestModel.dealerId = null;
      this.searchTerm='';
  }
  onClose() {
    this.isAdvanceSearch = false;
  }
  onSearch() {
    this.isAdvanceSearch = true;
  }
  onQuickSerch() {
    this.appointmentRequestModel.searchTerm = this.searchTerm;
    this.appointmentRequestModel.languageCode=this.cookieservice.get('userSelectedLanguage');
    this.getAllServiceAdvisorDetails(this.appointmentRequestModel);
  }

  onDealerChange(){
    this.appointmentRequestModel.dealerId = this.selectedDealer;
    this.appointmentRequestModel.languageCode=this.cookieservice.get('userSelectedLanguage');
    this.getAllServiceAdvisorDetails(this.appointmentRequestModel);
  }
  refresh(){
    this.appointmentRequestModel.languageCode=this.cookieservice.get('userSelectedLanguage');
    this.getAllServiceAdvisorDetails(this.appointmentRequestModel);
  }

  getNextAvailbleStatus(appointmentStatusId,language,appointmentId){
    this.appointmentService.GetNextAvailableStatus(appointmentStatusId,language,appointmentId).then((res)=>{
      if(res.responseObject.errorCount === undefined || res.responseObject.errorCount === null){
        this.statusList = res.responseObject;
      }
    })
  }

  editAppointmentCallForClick(appointment){
        this.isSingleClick = true;
            setTimeout(()=>{
                if(this.isSingleClick){
                  this.editAppointment(appointment);
                }
              },250)
    }

    updateStatusForDblClick(content,appointment){
              this.isDisplayInvoice = false;
              this.isSingleClick = false;
              this.statusList=[];
              this.open(content,appointment);
    }
    onBlur(event) {
      this.InvoicePrice = event.target.value;

    }
  open(content,appointment) {
    this.IsLockedByOtherUser(appointment);
    this.InvoicePrice = '';
    this.SelectedStatus = null;
    let language = this.cookieservice.get('userSelectedLanguage')
    this.getNextAvailbleStatus(appointment.workOrderStatusId,language,appointment.id)
    this.updateAppointmentStatusModel.customerName = appointment.customerName;
    this.updateAppointmentStatusModel.dealerName = appointment.dealer;
    this.updateAppointmentStatusModel.licensePlate = appointment.licensePlate;
    this.updateAppointmentStatusModel.WOnumber = appointment.workOrder;
    this.updateAppointmentStatusModel.WOstatusColor = appointment.workOrderStatusColor;
    this.updateAppointmentStatusModel.appointmentId = appointment.id;
    this.updateAppointmentStatusModel.appointmnetStatusColor = appointment.appointmentStatusColor;
    this.updateAppointmentStatusModel.bookDate = appointment.bookedDate;
    this.updateAppointmentStatusModel.WOstatusId = appointment.workOrderStatusId;
    this.updateAppointmentStatusModel.WOstatus = appointment.workOrderStatus;
    this.updateAppointmentStatusModel.model = appointment.modelName;
    this.updateAppointmentStatusModel.appointmentStatusId = appointment.appointmentStatusId;
    this.updateAppointmentStatusModel.brandImg = appointment.brand;
    this.updateAppointmentStatusModel.appointmentGuid = appointment.appointmentGuid;
    this.updateAppointmentStatusModel.appointmentStatus = appointment.appointmentStatus;
    this.updateAppointmentStatusModel.bookDateTime=appointment.bookedDate;
    this.updateAppointmentStatusModel.customerGuid=appointment.customerGuid;
    this.updateAppointmentStatusModel.makeCode = appointment.brandCode;
    this.modalService.open(content, {size: 'lg', ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

 
  updateStatus() {
    this.isCurrentAppointmentOnHold = (this.updateAppointmentStatusModel.WOstatusId === Enums.WOStatus.OnHold);

    this.spinner.show();

    if (this.ValidateInvoicePrice()) {
        this.spinner.hide();
        return;
    }

    if (this.DisplayErrorMessage()) {
        this.spinner.hide();
        return;
    }

    if (this.UpdateAppointmentStatus()) {
        this.updateAppointment();
        
    }

    this.spinner.hide();
}

ValidateInvoicePrice() {
    if (
        this.SelectedStatus === Enums.WOStatus.InvoicePaid &&
        this.isDisplayInvoice &&
        (this.InvoicePrice == null || this.InvoicePrice == undefined)
    ) {
        this.toastr.error("Add amount");
        return true;
    }

    if (this.SelectedStatus === Enums.WOStatus.InvoicePaid && this.isDisplayInvoice) {
        let regexp = new RegExp(/^[\d,.\s]+$/);
        let isValidInput = regexp.test(this.InvoicePrice);

        if (!isValidInput) {
            let msg = this.translate.instant("lblValidInputForInvoice");
            this.toastr.error(msg);
            return true;
        }
    }

    return false;
}

DisplayErrorMessage() {
    let todayDate = new Date();

    if (
        (this.SelectedStatus === Enums.WOStatus.Invoiceready ||
            this.SelectedStatus === Enums.WOStatus.InvoicePaid ||
            this.SelectedStatus === Enums.WOStatus.Closed) &&
        new Date(this.updateAppointmentStatusModel.bookDateTime).getTime() > new Date(todayDate).getTime()
    ) {
        let statusUpdateError = this.translate.instant("lblStatusUpdateErrorMsg");
        this.toastr.error(statusUpdateError);
        document.getElementById("modelButton").click();
        return true;
    }

    return false;
}

UpdateAppointmentStatus() {
    return (
        this.updateAppointmentStatusModel?.appointmentGuid &&
        this.SelectedStatus
    );
}
empty(e: any) {
  switch (e) {
    case "":
    case null:
    case undefined:
      return true;
    default:
      return false;
  }
}
updateAppointment() {
    let viewmodel = {
        WorkOrderStatusId: this.SelectedStatus,
        AppointmentGuid: this.updateAppointmentStatusModel.appointmentGuid,
        InvoicePrice: this.globalSetting.getFormattedprice(this.InvoicePrice),
      CustomerGuid: this.updateAppointmentStatusModel.customerGuid,
      BrandCode: this.updateAppointmentStatusModel.makeCode
    };

    this.appointmentService.UpdateAppointmentStatus(viewmodel).then((res) => {
      if (res.responseObject?.isSuccess) {
          if(!this.empty(res.responseObject.resultMessage)){
            this.toastr.error(res.responseObject.resultMessage);
            }
            if (viewmodel.WorkOrderStatusId === Enums.WOStatus.Prepared) {
                this.appLinkService.GetCheckInUrl(viewmodel.AppointmentGuid);
            }

            this.appointmentRequestModel.languageCode = this.cookieservice.get('userSelectedLanguage');
            this.getAllServiceAdvisorDetails(this.appointmentRequestModel);

            if (this.isCurrentAppointmentOnHold && viewmodel.WorkOrderStatusId !== Enums.WOStatus.Cancelled) {
                let msg = this.translate.instant("lblRescheduleAppointmentMessage");
                msg += this.updateAppointmentStatusModel.WOnumber;
                let modelHeadermsg = this.translate.instant("lblActivateWorkOrder");
                const modalRef = this.modalService.open(NgInfoModalContent);
                modalRef.componentInstance.modelHeader = modelHeadermsg;
                modalRef.componentInstance.modelBody = msg;
                modalRef.result.then((_result) => {
                    // This is intentional
                }, (reason) => {
                    this.popupCloseResult = this.getDismissDeleteReason(reason);
                });
            }
        } else {
            this.toastr.error("Status not updated");
            this.appointmentRequestModel.languageCode = this.cookieservice.get('userSelectedLanguage');
            this.getAllServiceAdvisorDetails(this.appointmentRequestModel);
        }
    });

    document.getElementById("modelButton").click();
}

  private getDismissDeleteReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }

  public generateStatusTrackerLink(appointmentGuid) {
    let model = {
      AppointmentGuid: appointmentGuid
    };
    this.appLinkService.AddTrackerLink(model)
      .then(
        res => {
          console.info('HTTP response successfully.', res);
        },
        err => {
          console.error('HTTP Error', err);
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  async editAppointment(appointment)
  {
    this.appointmentService.isRefreshListing = true;
    this.multiStackPopupService.OpenAppointment(appointment.id);
  }

  //#region Edit Appointment Notification
  IsLockedByOtherUser(appointment: any){
    if (this.editAppointmentService.isLockFeatureEnabled) {
      this.appointmentService.IsLockedByOtherUser(appointment.appointmentGuid).then((res) => {
        const locked = res.responseObject;
        if (locked?.isLocked) {
          let modelBodymsg = this.translate.instant('lblUsedByAnotherUser');
          modelBodymsg = modelBodymsg.replace('##USER##', locked.lockedByName);
          this.isOpenByOtherUser = true;
          this.isOpenByOtherUserMsg = modelBodymsg;
        }
        else{
          this.isOpenByOtherUser = false;
        }
      });
    }
    else {
      this.isOpenByOtherUser = false;
    }
  }
  //#endregion

  getFormattedDate(dateRangeArray: any[]){
    let formattedDate: string= "";
    if(dateRangeArray.length != 0){
      let beginDate= this.datePipe.transform(dateRangeArray[0], 'dd/MM/yyyy');
      let lastDate= this.datePipe.transform(dateRangeArray[1], 'dd/MM/yyyy');
      formattedDate= beginDate + ' - ' + lastDate;
    }
    return formattedDate;
  }
}
